export default {
  master_title: 'Merkmodus - Menu',
  title: 'Menu',
  form: {
    has_internal_product_numbers: {
      label: 'Productnummers toewijzen',
      tooltip:
        'Wijs automatisch nummers toe aan producten op basis van hun positie in het menu. Het nummer wordt op de bonnen afgedrukt',
    },
  },
  buttons: {
    new_menu: 'Nieuw menu',
    export_menu: 'Menu exporteren',
    refresh: 'Vernieuwen',
  },
  modals: {
    delete_category: {
      title: '{{name}} verwijderen',
    },
    delete_products: {
      title: '{{count}} producten verwijderen?',
      description: '<strong>{{count}}</strong> worden verwijderd uit het menu',
    },
  },
  toasts: {
    failed_to_load_data: 'Gegevens laden mislukt',
    failed_to_delete_menu: 'Menu kon niet worden verwijderd, probeer opnieuw',
    menu_got_deleted: 'Menu verwijderd',
    failed_to_delete_category: 'Categorie kon niet worden verwijderd, probeer opnieuw',
    category_got_deleted: 'Categorie verwijderd',
    failed_to_delete_products: 'Producten konden niet worden verwijderd, probeer opnieuw',
    product_got_deleted_one: 'Product verwijderd',
    product_got_deleted_other: 'Producten verwijderd',
    failed_to_generate_product_number: 'Er is iets misgegaan. Laad de pagina opnieuw en probeer het nog eens',
    menu_exported: 'Menu is geëxporteerd',
    failed_to_export_menu: 'Menu exporteren mislukt',
  },
};
